import ReactApexChart from "react-apexcharts";
import { useContext } from "react";
import { ADCubeAdminContext } from "../../../../context/ADCubeAdminContext";

export const CostTargetGraph = ({
  xData,
  yLq,
  yMn,
  yUq,
  pointsX,
  pointsY,
  xLabel,
  yLabel,
  title,
  currentBudget,
  optimalBudget,
}) => {
  const adCubeAdminContext = useContext(ADCubeAdminContext);

  let points = [];
  let rangesData = [];
  let medianData = [];
  let series = [
    {
      type: "rangeArea",
      name: "Range",
      data: rangesData,
    },
    {
      type: "line",
      name: "Median",
      data: medianData,
    },
  ];

  //Load the lower and upper ranges and also the curves data,
  xData.forEach((num1, index) => {
    rangesData.push({
      x: num1,
      y: [yLq[index].toFixed(2), yUq[index].toFixed(2)],
    });
    medianData.push({
      x: num1.toFixed(2),
      y: yMn[index].toFixed(2),
    });
  });
  //Load the points data
  pointsX.forEach((num1, index) => {
    points.push({
      x: pointsX[index],
      y: pointsY[index],
      marker: {
        size: 1,
        fillColor: "#fff",
        strokeColor: "blue",
        radius: 2,
        cssClass: "apexcharts-custom-class",
      },
    });
  });

  const allX = [...xData, ...pointsX];
  const allY = [...yLq, ...yMn, ...yUq, ...pointsY];
  const xMin = Math.min(...allX);
  const xMax = Math.max(...allX);
  const yMin = Math.min(...allY);
  const yMax = Math.max(...allY);
  const yPadding = (yMax - yMin) * 0.05;

  let options = {
    chart: {
      height: 350,
      type: "rangeArea",
      animations: {
        speed: 500,
      },
      background: "transparent",
    },
    colors: ["#7267f0"],
    dataLabels: {
      enabled: false,
    },
    theme: {
      mode: adCubeAdminContext.themeLight ? "light" : "dark",
    },
    fill: {
      opacity: [0.24, 1],
    },
    stroke: {
      curve: "smooth",
      width: [0, 2],
    },
    title: {
      text: title,
    },
    xaxis: {
      min: xMin,
      max: xMax,
      tickAmount: 8,
      title: {
        text: xLabel,
      },
      labels: {
        formatter: (val) => {
          return Math.floor(val);
        },
      },
    },
    yaxis: {
      min: yMin - yPadding,
      max: yMax + yPadding,
      title: {
        text: yLabel,
        labels: {
          formatter: (val) => {
            return val;
          },
        },
      },
    },
    legend: {
      show: false,
    },
    markers: {
      hover: {
        sizeOffset: 5,
      },
    },
    annotations: {
      points: points,
      xaxis: [
        {
          x: currentBudget,
          borderWidth: 3,
          strokeDashArray: 0,
          label: {
            text: "Current budget",
            style: {
              background: adCubeAdminContext.themeLight ? "#ffffff" : "#000000",
            },
            position: "left",
          },
        },
        {
          x: optimalBudget,
          borderWidth: 3,
          strokeDashArray: 0,
          label: {
            text: "Last budget",
            style: {
              background: adCubeAdminContext.themeLight ? "#ffffff" : "#000000",
            },
          },
        },
      ],
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="rangeArea"
      height={350}
    />
  );
};
